<template>
  <div id="Payment">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>แจ้งชำระเงิน</h2>
          <b-card bg-variant="light" class="mb-3">
            <h4>รายละเอียดการโอนเงิน</h4>
            <b-row>
              <!-- <b-col sm="6" class="mb-2"> -->
              <b-col>
                <!-- <label for="bank_name" class="mb-1">จำนวนเงิน:</label>
                <b-form-input id="bank_name" autocomplete="off" class="mb-2" v-model="form.firstName" type="number" ></b-form-input> -->
                <b-form-group label="บัญชีที่โอนเงิน:" v-slot="{ ariaDescribedby }" class="mb-2">
                  <!-- <b-form-radio class="custom-radio-purple" v-model="form.bankAccountLicm"
                    :aria-describedby="ariaDescribedby" name="bank-radios"
                    value="027-8-24576-4">
                    ธนาคารกสิกรไทย 027-8-24576-4 นางสาวพีรญา แสงบุญเรือง
                  </b-form-radio> -->
                  <b-form-radio class="custom-radio-purple" v-model="form.bankAccountLicm"
                    :aria-describedby="ariaDescribedby" name="bank-radios"
                    value="165-235662-5">
                    ธนาคารไทยพาณิชย์ 165-235662-5 นส.บุษรินทร์ อ้นแขกสุวรรณ
                  </b-form-radio>
                </b-form-group>

                <label for="transferDate" class="mb-1">วันที่ชำระเงิน:</label>
                <b-form-datepicker
                  id="transferDate"
                  reset-button
                  close-button
                  locale="th"
                  placeholder="เลือกวันที่เข้าโกดัง"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  class="mb-2"
                  v-model="form.transferDate"
                ></b-form-datepicker>

                <label for="transferTime" class="mb-1">เวลา (โดยประมาณ):</label>
                <b-form-timepicker id="transferTime"
                  v-model="form.transferTime" locale="th"
                  class="mb-2"
                  now-button
                  placeholder="เลือกเวลา"
                  label-now-button="เลือกเวลาปัจจุบัน"
                  label-close-button="ปิด"
                ></b-form-timepicker>

                <label for="form_amount" class="mb-1">จำนวนเงิน:</label>
                <b-input-group append="บาท" class="mb-2">
                  <b-form-input id="form_amount" autocomplete="off" v-model="form.amount" type="number"></b-form-input>
                </b-input-group>
              <!-- </b-col>

              <b-col sm="6"> -->
                <div class="mb-1">หลักฐานการโอนเงิน:</div>
                <b-form-file v-model="fileimg" ref="file-input-img"
                  @input="uploadFile()" browse-text="เลือกไฟล์" accept="image/*"
                  drop-placeholder="แนบไฟล์สลิปการโอนเงิน" placeholder="แนบไฟล์สลิปการโอนเงิน"
                  class="mb-3"></b-form-file>

                <b-img thumbnail fluid width="350" center :src="form.pictureSlip" v-if="form.pictureSlip" alt="หลักฐานการโอนเงิน"></b-img>
              </b-col>
            </b-row>
          </b-card>

          <b-card bg-variant="light" class="mb-3">
            <h4>เลือกรายการสั่งออกที่จะชำระเงิน</h4>
            <b-row>
              <b-col>
                <b-table striped responsive outlined small
                  :items="items" :fields="fields"

                  head-variant="light"
                  table-variant="light"

                  select-mode="single"
                  ref="selectInvoice"
                  selectable
                  @row-selected="onInvoiceSelected"
                  :busy="!dataReady"
                  class="table-mini">

                  <template #head(selected)=" {} ">

                  </template>

                  <template #cell(selected)="data">
                    <template v-if="data.rowSelected">
                      <f-icon icon="dot-circle" class="text-purple animate__animated animate__tada"></f-icon>
                    </template>
                    <template v-else>
                      <f-icon icon="circle"></f-icon>
                    </template>
                  </template>

                  <!-- <template #cell(createDatetime)="data">
                    {{ data.value.date }}<br>{{ data.value.time }}
                  </template>

                  <template #cell(lastDatetime)="data">
                    {{ data.value.date }}<br>{{ data.value.time }}
                  </template> -->

                </b-table>

                <label for="noteSlip" class="mb-1">รายละเอียดเพิ่มเติม:</label>
                <b-form-input id="noteSlip" autocomplete="off" class="mb-2" v-model="form.noteSlip" type="text"></b-form-input>

                <p><small class="text-muted">*กรุณาตรวจทานรายละเอียดให้ถูกต้องอีกครั้ง ก่อนยืนยันการแจ้งชำระเงิน</small></p>
              </b-col>
            </b-row>
          </b-card>

          <hr>

          <div class="text-center mt-2">
            <b-button variant="purple" size="lg" @click="onSubmit()" v-if="dataReady" :disabled="form.deliverDoc === ''">
              <f-icon icon="receipt"></f-icon>
              แจ้งชำระเงิน
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Payment",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น

    this.getDateNow()
    this.getDataUser()
    await this.getDataInvoices()
  },
  data() {
    return {
      fields: [
        'selected',
        { key: 'deliverDoc', label: 'รหัสใบชำระสินค้า', thClass: 'py-2' },
        { key: 'userCode', label: 'รหัสสมาชิก', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
        // { key: 'createDatetime', label: 'วันที่สร้าง', thClass: 'py-2 text-center', tdClass: 'text-center' },
        // { key: 'lastDatetime', label: 'วันที่ทำรายการ', thClass: 'py-2 text-center', tdClass: 'text-center' },
        { key: 'transportType', label: 'ประเภทการจัดส่ง', thClass: 'py-2 text-center' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'py-2 text-center', tdClass: 'font-weight-light' },
        { key: 'amountPaid', label: 'ราคารวม', thClass: 'py-2 text-center' },
        { key: 'status', label: 'สถานะ', thClass: 'py-2 text-center', tdClass: 'text-center font-weight-bold' },
      ],
      items: [],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        bankAccountLicm: "027-8-24576-4",
        transferDate: "",
        transferTime: "",
        amount:  "",
        pictureSlip: "",
        noteSlip: "",
        deliverDoc: "",
        userName: "",
        CREATE_USER: "",
        status: "รอยืนยันการชำระ",
      },
      fileimg: null,
      dataReady: false,
    };
  },
  methods: {
    getDateNow () {
      let dateTime = this.getNowGlobal().split(' ')
      this.form.transferDate = dateTime[0]
      this.form.transferTime = dateTime[1]
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser

        this.form.CREATE_USER = this.userData.userName
        this.form.userName = this.userData.userName
        // this.form.userCode = this.userData.userCode
      } else {
        this.$router.push('/Login')
      }
    },
    getDataInvoices () {
      this.dataReady = false
      this.items = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Deliver_detail/Deliver_detail_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          uc +
          '&status=รอตรวจสอบ',
          {
            headers: this.getHeaderAPI('Deliver_detail_list', this.userData.userName)
          }
        )
        .then((response) => {
          // console.log('getDataInvoices', response.data)

          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let invoiceData = rs.data[i]

                // invoiceData.createDatetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                // invoiceData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)

                this.items.push(invoiceData)
              }
            }
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataInvoices error:', error)
          this.dataReady = true
          this.items = []
        });
    },
    getFileBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async uploadFile () {
      if (this.fileimg) {
        await this.getFileBase64(this.fileimg)
          .then(picBase64 => {
            // console.log('uploadFile Base64', picBase64)
            this.form.pictureSlip = picBase64
          })
      }
    },
    onInvoiceSelected (invoice) {
      // let dataInvice = invoice[0]
      console.log("onInvoiceSelected", invoice)
      if (invoice.length > 0) {
        this.form.deliverDoc = invoice[0].deliverDoc
      } else {
        this.form.deliverDoc = ''
      }
    },
    onSubmit () {
      console.log("onSubmit Data:", this.form)
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Slip/Slip_add",
          this.form,
          {
            headers: this.getHeaderAPI('Slip_add', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แจ้งการชำระเงินเรียบร้อย","success")
              .then((result) => {
                this.$router.push('/Route?target=Delivery&uriType=User')
              })
            this.dataReady = true
          } else {
            console.log('onSubmit Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแจ้งการชำระเงินได้ กรุณาติดต่อแอดมิน","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("Error Insert","ไม่สามารถแจ้งการชำระเงินได้ กรุณาติดต่อแอดมิน","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/User/Payment.vue